<div class="p-3">
  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
    <h4 class="mb-0">Referral Rolling Account</h4>
    <a class="btn btn-sm btn-outline-primary" [routerLink]="['/lo', company_uuid, 'agent-commission-overview']">
      Agent Commission Overview →
    </a>
  </div>
  <div class="alert alert-info py-2 mb-3">
    <strong>{{ period.label }}</strong>
    <span *ngIf="period.from_date"> — {{ period.from_date }} to {{ period.to_date }}</span>
    <span class="ms-2 text-muted small">
      Referral-tier rolling is credited to the earning member's referral wallet as Daily Rolling.
    </span>
  </div>

  <div class="rolling-filter mb-3">
    <div class="rolling-filter__field rolling-filter__field--period">
      <label class="form-label fw-bolder mb-1">Period</label>
      <select class="form-select form-select-sm"
              [ngModel]="selectedPeriodKey"
              (ngModelChange)="onPeriodChange($event)">
        <option *ngFor="let o of periodOptions" [value]="o.key">
          {{ o.label }} ({{ o.from_date }} - {{ o.to_date }})
        </option>
        <option value="custom">Custom Range</option>
      </select>
    </div>
    <div class="rolling-filter__field">
      <label class="form-label fw-bolder mb-1">From</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="filter.from_date" (ngModelChange)="selectedPeriodKey = 'custom'">
    </div>
    <div class="rolling-filter__field">
      <label class="form-label fw-bolder mb-1">To</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="filter.to_date" (ngModelChange)="selectedPeriodKey = 'custom'">
    </div>
    <div class="rolling-filter__actions">
      <button type="button" class="btn btn-sm btn-primary" (click)="search()" [disabled]="loading || !filter.from_date || !filter.to_date">
        Search
      </button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="reset()" [disabled]="loading">
        Reset
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="text-muted">Loading…</div>

  <div class="rolling-summary mb-3" *ngIf="!loading">
    <div class="rolling-summary__item">
      <div class="rolling-summary__label">Referral Wallet Payout</div>
      <div class="rolling-summary__value">{{ memberCommissionTotal | number:'1.3-3' }}</div>
    </div>
    <div class="rolling-summary__item rolling-summary__item--bucket">
      <div class="rolling-summary__label">Company Bucket</div>
      <div class="rolling-summary__value">{{ bucketTotal | number:'1.3-3' }}</div>
    </div>
    <div class="rolling-summary__item rolling-summary__item--highlight">
      <div class="rolling-summary__label">Total Pool</div>
      <div class="rolling-summary__value">{{ totalCommissionPool | number:'1.3-3' }}</div>
    </div>
    <div class="rolling-summary__item">
      <div class="rolling-summary__label">Earning Members</div>
      <div class="rolling-summary__value">{{ earningMemberCount }} / {{ agents.length }}</div>
    </div>
    <div class="rolling-summary__item">
      <div class="rolling-summary__label">Report Rows</div>
      <div class="rolling-summary__value">{{ reportRowTotal }}</div>
    </div>
  </div>

  <table class="table table-striped" *ngIf="!loading && agents.length > 0">
    <thead>
      <tr>
        <th>Member Code</th>
        <th>Member Name</th>
        <th class="text-end">Referral Wallet Payout</th>
        <th class="text-end">Rows</th>
        <th class="text-end">Rate</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let a of agents">
        <td>
          <a *ngIf="a.player_uuid; else plainCode" href="javascript:void(0)" (click)="openMember(a)"
             title="Open wallet topup/withdraw &amp; referral history">{{ a.agent_code }}</a>
          <ng-template #plainCode>{{ a.agent_code }}</ng-template>
        </td>
        <td>{{ a.agent_name }}</td>
        <td class="text-end">{{ a.total_commission | number:'1.3-3' }}</td>
        <td class="text-end">{{ a.row_count }}</td>
        <td class="text-end">{{ (a.rate * 100) | number:'1.0-2' }}%</td>
        <td class="text-end">
          <button class="btn btn-sm btn-outline-primary" (click)="drill(a)">View</button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!loading && agents.length === 0" class="text-muted">No earning members found for this company.</div>

  <div class="mt-4" *ngIf="!loading">
    <h5 class="mb-2">Company Commission Bucket <span class="badge bg-secondary">{{ period.label }}</span></h5>
    <div *ngIf="bucketLoading" class="text-muted small">Loading bucket…</div>
    <div *ngIf="!bucketLoading && bucketRows.length === 0" class="text-muted small">No bucket entries for this period.</div>
    <table class="table table-sm table-bordered" *ngIf="!bucketLoading && bucketRows.length > 0">
      <thead class="table-dark">
        <tr>
          <th>Date</th>
          <th class="text-end">Net Profit</th>
          <th class="text-end">Bucket Rate</th>
          <th>Calculation</th>
          <th class="text-end">Bucket Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let b of bucketRows">
          <td>{{ b.date }}</td>
          <td class="text-end">{{ b.net_profit | number:'1.3-3' }}</td>
          <td class="text-end">{{ (b.bucket_rate * 100) | number:'1.0-2' }}%</td>
          <td class="small text-muted">
            <div>{{ b.formula_text || '-' }}</div>
            <div class="bucket-breakdown" *ngIf="bucketGameBreakdown(b).length > 0">
              <div *ngFor="let g of bucketGameBreakdown(b)">
                {{ g.game }}<ng-container *ngIf="g.game_type"> / {{ g.game_type }}</ng-container>:
                {{ g.formula_text }} = {{ g.amount | number:'1.3-3' }}
              </div>
            </div>
          </td>
          <td class="text-end fw-bold">{{ b.amount | number:'1.3-3' }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="table-warning fw-bold">
          <td colspan="4">Total</td>
          <td class="text-end">{{ bucketTotal | number:'1.3-3' }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
